package com.appsyde.shared.modules.ticket.domain.model

/**
 * Domain result for "assign up to N tickets" operation.
 * Contains the list of assignment results (each can be Success or AssignedToOther when parsed from API).
 */
data class AssignUpToResult(
    val assigned: List<AssignTicketResult>
)
